module.exports = {
    theme: {
        extend: {
            screens:{
                'xs': { max:'639px' }
            },
            colors: {
                palette: {
                    darkgray: '#1a1415',
                    lightgray: '#a8aeab',
                    gray: '#474A49',
                    beige: '#F4F0EA',
                    darkblue: '#033062',
                    greyishblue: '#daecf6',
                    darkerblue: '#002146',
                    middleblue: '#87BCE7',
                    pink: '#dfbfb5',
                    lightblue: '#DEE9F4',
                    orange: '#e9774e',
                    mapblue: '#0076F8',
                    babyblue: '#F9FCFE' // was #e1f1f4
                }
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            },
            opacity: {
                '5': '.05',
                '60': '.6',
                '80': '.8',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },
    variants: {},
    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/common/*.{vue,js,scss,php}',
    ],
};
